/*
*+------------------------------------------------------------------------+
*| Licensed Materials - Property of IBM
*| IBM Cognos Products: BI Dashboard
*| (C) Copyright IBM Corp. 2019
*|
*| US Government Users Restricted Rights - Use, duplication or disclosure
*| restricted by GSA ADP Schedule Contract with IBM Corp.
*+------------------------------------------------------------------------+
*/

/**
* The ConceptsFetcherFeature
**/

define([
	'dashboard-analytics/features/widget/renderSequence/api/RenderStepProviderAPI',
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'./SmartColorRenderStep'
], function(RenderStepProviderAPI, APIFactory, SmartColorRenderStep) {

	class SmartsColorRenderStepProvider {
		constructor(options) {
			// RenderSequence is a dependency so it is automatically passed in
			options.features.RenderSequence.registerRenderStepProvider(this.getAPI());

			this.smartColorMapAPI = options.features['Dashboard.SmartColorMap'];
		}

		destroy() {}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [RenderStepProviderAPI]);
			}
			return this.api;
		}

		getRenderStepList() {
			return [
				{
					id: 'smartColorMapRenderStep',
					dependencies:['data'],
					blocks: ['render'],
					module: SmartColorRenderStep,
					moduleOptions: { smartColorMapAPI:  this.smartColorMapAPI }
				}
			];
		}
	}

	return SmartsColorRenderStepProvider;
});
